import { toast } from "react-toastify";
import { instance } from "./api";
const url = process.env.REACT_APP_BASE_URL || "/";

async function getworkshopAdmin(page, limit, filter, companyId) {
  // call the api for getworkshopAdmin list

  const api =
    url +
    `/companies/${companyId}/users?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}`;

  return await instance
    .get(api)
    .then((response) => {
      return response
    })
    .catch((error) => {
      return error?.response;
    });
}

async function getWorkshopUsers(companyId, userId, t) {
  // call the api for getworkshopAdmin list

  const api = url + `/companies/${companyId}/users/${userId}/workshops`;

  return await instance
    .get(api)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      if (error?.response?.data?.error?.error_code) {
        toast.error(t(error?.response?.data?.error?.error_code), {
          toastId: 3,
        });
      }
      return error?.response?.data;
    });
}

async function allocateWorkshops(companyId, userId, data, t) {
  // call the api for getworkshopAdmin list

  const api = url + `/companies/${companyId}/users/${userId}/workshops/save`;

  return await instance
    .put(api, { workshops: data })
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      if (error?.response?.data?.error?.error_code) {
        toast.error(t(error?.response?.data?.error?.error_code), {
          toastId: 3,
        });
      } else {
        toast.error(
          t(error?.response?.data?.error?.details[0]?.errors[0]?.error_code),
          {
            toastId: 3,
          }
        );
      }
      return error?.response?.data;
    });
}

export const workshopAdmins = {
  getworkshopAdmin,
  getWorkshopUsers,
  allocateWorkshops,
};
